import * as React from "react";
import { Flex, Image } from "@chakra-ui/react";
import { Outlet } from "react-router-dom";
import logo from "assets/logo.png";

const LoginLayout: React.FC = () => (
  <Flex
    direction="column"
    justifyContent="center"
    alignItems="center"
    h="100vh"
  >
    <Flex justifyContent="center" mb="12">
      <Image w="158px" h="60px" src={logo} alt="Logo" />
    </Flex>
    <Outlet />
  </Flex>
);

export default LoginLayout;
